import React, { useMemo, useState } from "react";
import { DatePicker, Table, Select } from "antd";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { endOfMonth, format, startOfMonth } from "date-fns";
import dayjs from "dayjs";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";

import ReportTools from "Components/UI/ReportTools";
import {
  useEmpLeaveHistoryReportQuery,
  useLeaveReportQuery,
} from "AppQuries/report/get-leave-report";
import { BackIcon } from "Components/UI/Icon/Icons";
const { RangePicker } = DatePicker;
const EmpLeaveHistory = () => {
  const userData = useSelector(loggedInUser);
  const [filterData, setFilterData] = useState({
    fromDate: format(startOfMonth(new Date(), 1), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date(), 1), "yyyy-MM-dd"),
    employeeCode: 0,
    locationCode: userData?.selectedLocationCode,
    companyCode: userData?.companyCode,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
    userId: userData?.userID,
  });

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getReport,
  } = useEmpLeaveHistoryReportQuery(
    { ...filterData },
    {
      enabled: !!filterData?.companyCode && !!filterData?.locationCode,
    }
  );

  const reportData = useMemo(
    () =>
      data && data?.length > 0
        ? data.map((d, _id) => ({
            ...d,
            id: _id + 1,
            fromDate: format(new Date(d?.fromDate), "dd-MM-yyyy"),
            toDate: format(new Date(d?.toDate), "dd-MM-yyyy"),
            isPaidLeave: d?.isPaidLeave ? "Yes" : "No",
            isApproved: d?.isApproved ? "Yes" : "No",
            totalDays: `${d?.totalDays} Days`,
          }))
        : [],
    [data]
  );
  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const employeeOptions =
    employees
      ?.filter((d) => d.isActive)
      .map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId}-${o.fullName}`,
        value: o.employeeCode,
      })) || [];
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Leave Name",
      dataIndex: "leaveName",
    },
    {
      title: "Leave Type",
      dataIndex: "leaveType",
    },
    {
      title: "Leave From",
      dataIndex: "fromDate",
    },
    {
      title: "Leave To",
      dataIndex: "toDate",
    },
    {
      title: "No Of Days",
      dataIndex: "totalDays",
    },
    {
      title: "Is Paid Leave",
      dataIndex: "isPaidLeave",
    },
    {
      title: "Is Approved",
      dataIndex: "isApproved",
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns
  );

  const updateQueryParams = (key, value) => {
    setFilterData((prev) => ({ ...prev, [key]: value }));
  };
  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Leave History Report</h4>
              <h6>View Employee Leave History</h6>
            </div>
          </div>
          <ReportTools
            columns={columns}
            data={reportData}
            fileName={`Leave History Report ${filterData?.fromDate} - ${filterData?.toDate}`}
            pdfTheme="striped"
            refresh={getReport}
          />
          <div className="page-btn">
            <Link
              to={`${all_routes.report_list}`}
              f
              className="btn btn-secondary"
            >
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Start Date – End Date</label>
                        <RangePicker
                          className="form-control"
                          style={{ display: "flex" }}
                          onChange={(date, dateFormat) => {
                            if (date) {
                              updateQueryParams("fromDate", dateFormat[0]);
                              updateQueryParams("toDate", dateFormat[1]);
                            }
                          }}
                          defaultValue={[
                            dayjs(filterData.fromDate, "YYYY-MM-DD"),
                            dayjs(filterData.toDate, "YYYY-MM-DD"),
                          ]}
                          dateFormat="YYYY-MM-DD"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                          // disabledDate={(current) => {
                          //   return current && current > dayjs().startOf("day");
                          // }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Employee</label>
                        <Select
                          value={
                            filterData?.employeeCode
                              ? filterData?.employeeCode
                              : ""
                          }
                          options={employeeOptions}
                          allowClear={true}
                          onSelect={(selectedOption) => {
                            updateQueryParams("employeeCode", selectedOption);
                          }}
                          onClear={() => {
                            updateQueryParams("employeeCode", 0);
                          }}
                          className="form-control"
                          variant="borderless"
                          showSearch={true}
                          filterOption={(input, option) =>
                            option.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={getReport}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : (
                            <>Filter</>
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                className="table  datanew"
                columns={columns}
                dataSource={filteredData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmpLeaveHistory;
